import { CommandProps, Mark, mergeAttributes } from '@tiptap/core';
import { v4 as uuid } from 'uuid';

// Add command to generate UUID
export const generateCommentId = () => uuid();

export const CommentMark = Mark.create({
  name: 'commentMark',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      commentIds: {
        default: '',
        parseHTML: (element) => element.getAttribute('data-comment-ids') || '',
        renderHTML: (attributes) => ({
          'data-comment-ids': attributes.commentIds,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-comment-ids]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        class: 'comment-marker',
      }),
      0,
    ];
  },

  addCommands() {
    return {
      setCommentMark:
        (commentId: string) =>
        ({ commands, state }: CommandProps) => {
          const { from, to } = state.selection;
          if (from === to) return false;
          return commands.setMark(this.name, { commentIds: commentId });
        },

      removeCommentMark:
        (commentId: string) =>
        ({ state, dispatch, tr }) => {
          if (!dispatch) return false;

          const { doc } = state;
          let modified = false;
          const newTr = tr || state.tr;

          doc.descendants((node, pos) => {
            if (node.isText && node.marks) {
              node.marks.forEach((mark) => {
                if (mark.type === this.type) {
                  const ids = mark.attrs.commentIds
                    .split(',')
                    .filter((id: string) => id.trim() !== commentId);
                  const originalIds = mark.attrs.commentIds.split(',');

                  if (ids.length === 0) {
                    // Remove the entire mark - need to find the exact range
                    const from = pos;
                    const to = pos + node.nodeSize;
                    newTr.removeMark(from, to, this.type);
                    modified = true;
                  } else if (ids.length !== originalIds.length) {
                    // Update the mark with remaining IDs
                    const from = pos;
                    const to = pos + node.nodeSize;
                    newTr
                      .removeMark(from, to, this.type)
                      .addMark(from, to, this.type.create({ commentIds: ids.join(',') }));
                    modified = true;
                  }
                }
              });
            }
          });

          if (modified) {
            dispatch(newTr);
          }
          return modified;
        },
    };
  },
});
